<nav class="p-4">
  <div class="px-0">
    <div class="relative flex items-center py-3">
      <div class="flex items-center gap-3 pl-4 md:pl-6 pr-4">
        <img
          src="assets/EVEintelligence_Logo.png"
          alt="EVE Intelligence"
          class="h-48 md:h-12 object-contain shrink-0"
        />
      </div>
      <div class="hidden md:block w-full justify-end">
        <div class="flex justify-end gap-6">
          <a
            routerLink="/"
            (click)="setActiveLink($event)"
            class="{{
              activeLink.play ? 'active' : ''
            }} px-3 text-gray-600 hover:text-custom-lt-blue font-medium hover:border-b-custom-lt-blue border-transparent border-b-2"
            >Play</a
          ><a
            href="/#howitworks"
            (click)="setActiveLink($event)"
            class="{{
              activeLink.howitworks ? 'active' : ''
            }} px-3 text-gray-600 hover:text-custom-lt-blue font-medium hover:border-b-custom-lt-blue border-transparent border-b-2"
            >How It Works</a
          >
          <a
            href="/#feedback"
            (click)="setActiveLink($event)"
            class="{{
              activeLink.feedback ? 'active' : ''
            }} px-3 text-gray-600 hover:text-custom-lt-blue font-medium hover:border-b-custom-lt-blue border-transparent border-b-2"
            >Feedback</a
          >
          <!-- <a
            routerLink="/learnmore"
            routerLinkActive="active"
            class="px-3 text-gray-600 hover:text-custom-lt-blue font-medium hover:border-b-custom-lt-blue border-transparent border-b-2"
            >Learn More</a
          >
          <a
            routerLink="/feedback"
            routerLinkActive="active"
            class="px-3 text-gray-600 hover:text-custom-lt-blue font-medium hover:border-b-custom-lt-blue border-transparent border-b-2"
            >Feedback</a
          > -->
        </div>
      </div>
    </div>
  </div>
</nav>
